export default __webpack_public_path__ + "static/media/Icon-1.bd3d092a.svg";